<template>
  <service-category>

    <layout-header-title slot="header" title="이마트24 정책"/>

    <div class="category" slot="category">

      <layout-two-column title="노쇼 기간">

        <layout-input v-model="editable.e24NoshowLimitDays"
                      class="input"
                      type="number"
                      :regex="regex(0, 100).num"/> <span class="unit-text">일</span>

      </layout-two-column>

      <p class="info">노쇼 기간은 숫자 1당 1일 입니다. ex) 1 (1일)</p>

      <layout-two-column title="주문 마감 시간">

        <layout-input v-model="editable.e24OrderCutoffHour"
                      class="input"
                      type="number"
                      :regex="regex(0, 100).num"/> <span class="unit-text">시</span>

      </layout-two-column>

      <p class="info">주문이 마감되는 시간을 입력해주세요 ex) 밤 12시 = 24시</p>

      <layout-two-column title="취소 마감 시간">

        <layout-input v-model="editable.e24CancelCutoffHour"
                      class="input"
                      type="number"
                      :regex="regex(0, 100).num"/> <span class="unit-text">시</span>

      </layout-two-column>

      <p class="info">취소가 마감되는 시간을 입력해주세요 ex) 밤 12시 = 24시</p>

      <layout-two-column title="점착 소요 일자">

        <layout-input v-model="editable.e24DeliveryDelayDays"
                      class="input"
                      type="number"
                      :regex="regex(0, 100).num"/> <span class="unit-text">일</span>

      </layout-two-column>

      <p class="info">이마트24 물류센터에서 점포까지 소요되는 일자를 입력해주세요</p>

    </div>

  </service-category>
</template>

<script>
import { regex } from '@/utils/utils';

import LayoutHeaderTitle from '@/spa/components/LayoutHeaderTitle';
import LayoutInput from '@/spa/components/LayoutInput';

import LayoutTwoColumn from '../LayoutTwoColumn';
import ServiceCategory from '../ServiceCategory';

export default {
  name: 'E24Policy',
  props: {
    e24NoshowLimitDays: Number,
    e24OrderCutoffHour: Number,
    e24CancelCutoffHour: Number,
    e24DeliveryDelayDays: Number,
  },
  components: {
    ServiceCategory,

    LayoutTwoColumn,
    LayoutHeaderTitle,
    LayoutInput,
  },
  methods: {
    regex(min, max) {
      return regex(min, max);
    },
  },
  watch: {
    'editable.e24NoshowLimitDays': {
      deep: true,
      handler(value) {
        this.$emit('onChangeE24NoshowLimitDays', value);
      },
    },
    'editable.e24OrderCutoffHour': {
      deep: true,
      handler(value) {
        this.$emit('onChangeE24OrderCutoffHour', value);
      },
    },
    'editable.e24CancelCutoffHour': {
      deep: true,
      handler(value) {
        this.$emit('onChangeE24CancelCutoffHour', value);
      },
    },
    'editable.e24DeliveryDelayDays': {
      deep: true,
      handler(value) {
        this.$emit('onChangeE24DeliveryDelayDays', value);
      },
    },
  },
  data() {
    return {
      editable: {
        e24NoshowLimitDays: this.e24NoshowLimitDays,
        e24OrderCutoffHour: this.e24OrderCutoffHour,
        e24CancelCutoffHour: this.e24CancelCutoffHour,
        e24DeliveryDelayDays: this.e24DeliveryDelayDays,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.category {
  width: 100%;
  min-width: 540px;

  .info {
    text-align: left;
    margin-top: 6px;
    margin-left: 174px;
    font-size: 12px;
    color: #666;
  }

  .unit-text {
    display: inline-block;
    width: 40px;
    text-align: left;
    margin-left: 10px;

    padding: 0;
  }

  .input {
    width: 100%;
    min-width: 150px;
    max-width: 350px;
  }
}

@media screen and (max-width: 1024px) {
  .category {
    width: 100%;
    min-width: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

    .input {
      width: auto !important;
    }

    .info {
      margin-left: 0;
      width: 80%;

      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/service/category/E24Policy.vue